import React, { useState } from 'react'
import { Header, Modal, Label, Icon, Table, Grid, Segment } from 'semantic-ui-react'
import ShowMoreText from "react-show-more-text";
import { useTranslation } from "react-i18next";

import "./RealstateDetails.css"

const info = {
    "View": "سنگی",
    "Floor": "چهارم",
    "W.C": "ایرانی ٬ فرنگی",
    "FloorType": "سرامیک",
    "Foundation": "۷۸",
    "Sleep": "۲",
    "Phone": "۱",
    "Kitchen": "MDF",
    "Balcony": "1",
    "Open": false,
    "Parking": true,
    "Warehouse": true,
}
const RealstateDetails = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<div className="RealstateDetails m-3-t m-3-b">

        <Segment>
        <Header as='h3'>{t("property:RealstateHighlights")}</Header>

        <Grid className="p-1-t p-1-b">
            {
                Object.keys(info).map(function (key, index) {
                    return <>
                        <Grid.Column computer={6} mobile={8} className="p-0-t p-0-b">
                            <Label size="large" basic className="text-g font-thin border-none white-nowrap">
                                <Icon name="caret right" />
                                {t(`property:${key}`)}
                            </Label>

                        </Grid.Column>
                        <Grid.Column computer={6} mobile={8}  className="p-0-t p-0-b">

                            {info[key] ?
                                (info[key] === true ? <Label size="large" basic className="border-none white-nowrap"><Icon name="checkmark box" color="green" /></Label> :
                                    <Label size="large" basic className="font-bold border-none white-nowrap">
                                        {/* <Icon name="angle double right" /> */}
                                        {info[key]}
                                    </Label>
                                ) : (<Label size="large" basic className="border-none"><span><Icon name="window close" color="red" /></span></Label>)
                            }

                        </Grid.Column>

                    </>

                })
            }
        </Grid>
        </Segment>
        {/* <Table basic="very" celled collapsing className="w-100">


            <Table.Body>
                {
                    Object.keys(info).map(function (key, index) {
                        return <Table.Row textAlign='center' >
                            <Table.Cell width="8">{t(`property:${key}`)}</Table.Cell>
                            <Table.Cell width="8">{info[key] ? (info[key] === true ? <Icon name="check" color="green" /> : info[key]) : (<Icon name="close" color="red" />)}</Table.Cell>

                        </Table.Row>

                    })
                }

            </Table.Body>
        </Table> */}

    </div>
    )
}
export default RealstateDetails